import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import { ButtonGroup } from '@material-ui/core';
const ButtonGroupStyle = styled(ButtonGroup)(({ theme, styleProps, }) => {
    const { color, variant } = styleProps;
    const styleContained = (color) => ({
        '& .MuiButtonGroup-grouped': {
            color: theme.palette[color].contrastText,
            backgroundColor: theme.palette[color].main,
            borderColor: `${theme.palette[color].dark} !important`,
            '&:hover': {
                backgroundColor: theme.palette[color].dark,
            },
        },
    });
    const styleOutlined = (color) => ({
        '& .MuiButtonGroup-grouped': {
            color: theme.palette[color].main,
            borderColor: `${alpha(theme.palette[color].main, 0.48)} !important`,
            '&:hover': {
                borderColor: `${theme.palette[color].main} !important`,
                backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
            },
        },
    });
    const styleText = (color) => ({
        '& .MuiButtonGroup-grouped': {
            color: theme.palette[color].main,
            borderColor: `${theme.palette[color].main} !important`,
            '&:hover': {
                backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
            },
        },
    });
    return {
        ...(variant === 'contained' && { ...styleContained(color) }),
        ...(variant === 'outlined' && { ...styleOutlined(color) }),
        ...(variant === 'text' && { ...styleText(color) }),
    };
});
export function MButtonGroup({ color = 'primary', variant = 'outlined', children, ...other }) {
    const theme = useTheme();
    if (color === 'inherit' || color === 'primary' || color === 'secondary') {
        return (_jsx(ButtonGroup, Object.assign({ color: color, variant: variant }, other, { children: children }), void 0));
    }
    return (_jsx(ButtonGroupStyle, Object.assign({ variant: variant, styleProps: { color, variant }, theme: theme }, other, { children: children }), void 0));
}
//# sourceMappingURL=MButtonGroup.js.map